module.exports = __webpack_public_path__ + "static/media/tinyLogout.35948cf2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tinyLogout.svg
// module id = 507
// module chunks = 0